import {
  type AppLocale,
  localeUsesRuRegionalFormat,
} from "@/shared/i18n/translations"

/**
 * Short date+time label in the app's UI locale (not the OS/browser locale),
 * e.g. "11 Jun, 14:39" (en) / "11 июн., 14:39" (ru/tonru).
 */
export function formatAppLocaleDateTimeShort(
  timestampMs: number,
  locale: AppLocale
): string {
  const intlLocale = localeUsesRuRegionalFormat(locale) ? "ru-RU" : "en-GB"
  const date = new Date(timestampMs)
  if (Number.isNaN(date.getTime())) return ""
  const datePart = date.toLocaleDateString(intlLocale, {
    day: "numeric",
    month: "short",
  })
  const timePart = date.toLocaleTimeString(intlLocale, {
    hour: "2-digit",
    minute: "2-digit",
  })
  return `${datePart}, ${timePart}`
}

/**
 * Short date+time label for an upcoming tournament's start moment,
 * e.g. "15 Aug, 12:00" (en) / "15 авг, 12:00" (ru/tonru).
 *
 * Day, abbreviated month, and HH:mm in 24-hour format — locale picks the
 * regional convention but the shape stays compact enough to fit alongside
 * a countdown in banners and sheets.
 */
export function formatTournamentStartsAt(
  startsAtMs: number,
  locale: AppLocale
): string {
  return formatAppLocaleDateTimeShort(startsAtMs, locale)
}
